"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { AdvSearchButton } from "./AdvSearchButton";

export function AdvSearchFacetGroup({ children = "", text = "Group Name" }) {
  return (
    <Block className={" bedroom-group"} tag={"div"}>
      <Block className={" text-44"} tag={"div"}>
        {text}
      </Block>
      <Block className={"bedroom-option"} tag={"div"}>
        {children ?? (
          <>
            <AdvSearchButton text={"Studio"} />
            <AdvSearchButton text={"1"} />
            <AdvSearchButton text={"2"} />
            <AdvSearchButton text={"3"} />
          </>
        )}
      </Block>
    </Block>
  );
}
